import { Box } from "@mui/material";
import SlotListComponent from "../../../component/Admin/SlotListComponent";

function SlotListPage () {

    return (
        <>
           
            <SlotListComponent />
        </>


    )
}
export default SlotListPage;